var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8332 12.082H2.1665V17.4987H18.8332V12.082Z",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7333 14.7917C15.7333 15.0356 15.5356 15.2333 15.2917 15.2333C15.0477 15.2333 14.85 15.0356 14.85 14.7917C14.85 14.5477 15.0477 14.35 15.2917 14.35C15.5356 14.35 15.7333 14.5477 15.7333 14.7917Z",
    fill: "#0699CE",
    stroke: "#0699CE",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1665 12.0824L4.26582 2.08203H16.7584L18.8332 12.0824",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 14.793H11.7498",
    stroke: "#0699CE",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSites);
export default __webpack_public_path__ + "static/media/sites.421ca6d9edb8573fb32bc86c246f7be8.svg";
export { ForwardRef as ReactComponent };